/*
 * 外部クライアントから設定画面（/settings/*）へ誘導する際の redirect クエリ判定。
 * redirect=settings/email 等の場合、redirect_uri は OAuth トークン返却先ではなく
 * 設定変更完了後の RP リダイレクト先として扱う。
 */

export const isSettingsFlowRedirect = (redirect) =>
	typeof redirect === 'string' && /^settings(\/|$)/.test(redirect);

/** @param {URLSearchParams} qs */
export const buildSettingsRedirectSearch = (qs) => {
	const params = new URLSearchParams();
	const redirectUri = qs.get('redirect_uri');
	const state = qs.get('state');
	const clientId = qs.get('client_id');
	if (redirectUri) params.set('redirect_uri', redirectUri);
	if (state) params.set('state', state);
	if (clientId) params.set('client_id', clientId);
	return params.toString();
};
